// /frontend/src/contexts/PackageContext.jsx - Updated with bedroom package details
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const PackageContext = createContext();

export const usePackage = () => useContext(PackageContext);

export const PackageProvider = ({ children }) => {
  const [packages, setPackages] = useState({
    bedroom: [],
    livingRoom: [],
    diningRoom: [],
    fullPackages: {
      oneBedroom: null,
      twoBedroom: null,
      threeBedroom: null
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [compareMode, setCompareMode] = useState(false);

  // Fetch packages data
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        setLoading(true);
        // Try to fetch from API, fall back to mock data if API is not ready
        try {
          // const { data } = await axios.get('/api/packages');
          // setPackages(data);
        } catch (apiError) {
          console.log('API not available, using mock data', apiError);
          
          // Mock data based on the images provided
          const mockPackages = {
            bedroom: [
              {
                id: 'bedroom-standard',
                name: 'Bedroom Package',
                description: 'Complete bedroom set with bed frame, nightstands, and dresser.',
                price: 2199,
                image: '/images/packages/bedroom-package.jpg',
                items: [
                  'Eastern King Bed Frame',
                  'Nightstand (2)',
                  'Table Lamp (2)',
                  'Dresser',
                  'Decorative Accessory (3)',
                  'Decorative Pillow (2)',
                  'Artwork (3)'
                ]
              }
            ],
            livingRoom: [
              {
                id: 'living-standard',
                name: 'Living Room Package',
                description: 'Complete living room furniture set including sofa, coffee table, and side tables.',
                price: 2499,
                image: '/images/packages/living-package.jpg',
                items: [
                  'Area Rug',
                  'Modular Sofa 2pcs',
                  'Coffee Table',
                  'Side Table (2)',
                  'Table Lamp (2)',
                  'Lounge Chair',
                  'Accent Table',
                  'Media Cabinet',
                  'Decorative Accessory (5)',
                  'Decorative Pillow (4)',
                  'Artwork'
                ]
              }
            ],
            diningRoom: [
              {
                id: 'dining-standard',
                name: 'Dining Room Package',
                description: 'Elegant dining set with table, chairs, and sideboard options.',
                price: 1899,
                image: '/images/packages/dining-package.jpg',
                items: [
                  'Dining Table',
                  'Dining Chair (6)',
                  'Decorative Accessory',
                  'Artwork'
                ]
              }
            ],
            fullPackages: {
              oneBedroom: {
                id: 'one-bedroom',
                name: '1 Bedroom Package',
                price: 35888,
                description: 'Complete 1 bedroom home package with 46 pre-set furnishing items',
                items: 46,
                roomBreakdown: {
                  entry: ['Artwork'],
                  kitchen: [
                    'Counter Stool',
                    'Counter Stool',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Artwork',
                    'Artwork'
                  ],
                  diningArea: [
                    'Dining Table',
                    'Dining Chair',
                    'Dining Chair',
                    'Decorative Accessory',
                    'Artwork'
                  ],
                  livingArea: [
                    'Area Rug',
                    'Modular Sofa 2pcs',
                    'Coffee Table',
                    'Side Table',
                    'Side Table',
                    'Table Lamp',
                    'Table Lamp',
                    'Lounge Chair',
                    'Accent Table',
                    'Media Cabinet',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Artwork'
                  ],
                  primaryBedroom: [
                    'Eastern King Bed Frame',
                    'Nightstand',
                    'Nightstand',
                    'Table Lamp',
                    'Table Lamp',
                    'Dresser',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Artwork',
                    'Artwork',
                    'Artwork'
                  ]
                }
              },
              twoBedroom: {
                id: 'two-bedroom',
                name: '2 Bedroom Package',
                price: 47888,
                description: 'Complete 2 bedroom home package with 60 pre-set furnishing items',
                items: 60,
                roomBreakdown: {
                  entry: ['Artwork'],
                  kitchen: [
                    'Counter Stool',
                    'Counter Stool',
                    'Counter Stool',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Artwork',
                    'Artwork'
                  ],
                  diningArea: [
                    'Dining Table',
                    'Dining Chair',
                    'Dining Chair',
                    'Dining Chair',
                    'Dining Chair',
                    'Dining Chair',
                    'Dining Chair',
                    'Decorative Accessory',
                    'Artwork'
                  ],
                  livingArea: [
                    'Area Rug',
                    'Modular Sofa 2pcs',
                    'Coffee Table',
                    'Side Table',
                    'Side Table',
                    'Table Lamp',
                    'Table Lamp',
                    'Lounge Chair',
                    'Accent Table',
                    'Media Cabinet',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Artwork'
                  ],
                  primaryBedroom: [
                    'Eastern King Bed Frame',
                    'Nightstand',
                    'Nightstand',
                    'Table Lamp',
                    'Table Lamp',
                    'Dresser',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Artwork',
                    'Artwork',
                    'Artwork'
                  ],
                  secondaryBedroom: [
                    'Queen Bed Frame',
                    'Nightstand',
                    'Table Lamp',
                    'Table Lamp',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Artwork',
                    'Artwork'
                  ]
                }
              },
              threeBedroom: {
                id: 'three-bedroom',
                name: '3 Bedroom Package',
                price: 58888,
                description: 'Complete 3 bedroom home package with 73 pre-set furnishing items',
                items: 73,
                roomBreakdown: {
                  entry: ['Artwork'],
                  kitchen: [
                    'Counter Stool',
                    'Counter Stool',
                    'Counter Stool',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Artwork',
                    'Artwork'
                  ],
                  diningArea: [
                    'Dining Table',
                    'Dining Chair',
                    'Dining Chair',
                    'Dining Chair',
                    'Dining Chair',
                    'Decorative Accessory',
                    'Artwork'
                  ],
                  livingArea: [
                    'Area Rug',
                    'Modular Sofa 2pcs',
                    'Coffee Table',
                    'Side Table',
                    'Side Table',
                    'Table Lamp',
                    'Table Lamp',
                    'Lounge Chair',
                    'Accent Table',
                    'Media Cabinet',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Decorative Pillow',
                    'Artwork'
                  ],
                  primaryBedroom: [
                    'Eastern King Bed Frame',
                    'Nightstand',
                    'Nightstand',
                    'Table Lamp',
                    'Table Lamp',
                    'Dresser',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Artwork',
                    'Artwork',
                    'Artwork'
                  ],
                  secondaryBedroom: [
                    'Queen Bed Frame',
                    'Nightstand',
                    'Nightstand',
                    'Table Lamp',
                    'Table Lamp',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Artwork',
                    'Artwork'
                  ],
                  thirdBedroom: [
                    'Queen Bed Frame',
                    'Nightstand',
                    'Table Lamp',
                    'Table Lamp',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Accessory',
                    'Decorative Pillow',
                    'Artwork',
                    'Artwork'
                  ]
                }
              }
            }
          };
          
          setPackages(mockPackages);
        }
        
        setLoading(false);
      } catch (err) {
        setError(err.message || 'Failed to fetch packages');
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);

  // Add a package to selected packages
  const addPackageToSelection = (packageId) => {
    // Check if already selected
    if (selectedPackages.includes(packageId)) {
      return;
    }
    setSelectedPackages([...selectedPackages, packageId]);
  };

  // Remove a package from selected packages
  const removePackageFromSelection = (packageId) => {
    setSelectedPackages(selectedPackages.filter(id => id !== packageId));
  };

  // Get a specific package by id
  const getPackageById = (packageId) => {
    // Check in each category
    const categories = ['bedroom', 'livingRoom', 'diningRoom'];
    for (const category of categories) {
      const found = packages[category].find(pkg => pkg.id === packageId);
      if (found) return found;
    }
    
    // Check in full packages
    const fullPackageKeys = ['oneBedroom', 'twoBedroom', 'threeBedroom'];
    for (const key of fullPackageKeys) {
      if (packages.fullPackages[key]?.id === packageId) {
        return packages.fullPackages[key];
      }
    }
    
    return null;
  };

  // Add package to cart
  const addPackageToCart = async (packageId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        // Handle not authenticated case
        console.log('User not authenticated');
        return { success: false, message: 'Please log in to add items to cart' };
      }
      
      const pkg = getPackageById(packageId);
      if (!pkg) {
        throw new Error('Package not found');
      }
      
      // Make API call to add package to cart
      // This would be an actual API call in production
      // const response = await axios.post(`/api/packages/${packageId}/add-to-cart`, {}, {
      //   headers: {
      //     Authorization: `Bearer ${token}`
      //   }
      // });
      
      // For now, simulate success
      console.log(`Adding package ${pkg.name} to cart`);
      
      return { success: true, message: 'Package added to cart successfully' };
    } catch (err) {
      console.error('Error adding package to cart:', err);
      return { 
        success: false, 
        message: err.response?.data?.message || 'Failed to add package to cart' 
      };
    }
  };

  // Toggle compare mode
  const toggleCompareMode = () => {
    setCompareMode(!compareMode);
    if (!compareMode) {
      // Clear selected packages when entering compare mode
      setSelectedPackages([]);
    }
  };

  return (
    <PackageContext.Provider
      value={{
        packages,
        loading,
        error,
        selectedPackages,
        compareMode,
        addPackageToSelection,
        removePackageFromSelection,
        getPackageById,
        addPackageToCart,
        toggleCompareMode,
      }}
    >
      {children}
    </PackageContext.Provider>
  );
};

export default PackageContext;